{
    "Profile_TestMode.title": "Test Mode",
    "Profile_TestMode.description": "Override dates for testing",
    "Profile_TestMode.descriptionDisabled": "Test mode is disabled globally",
    "Profile_TestMode.isPolicyInTestModeLabel": "Enable Test Mode for this Policy",
    "Profile_TestMode.realGoFirmDate": "Current GoFirmDate",
    "Profile_TestMode.goFirmDateTestLabel": "GoFirmDate Test"
}
